"use strict";

if (document.getElementById("app_attachments")) {
  var vueAttachments = new Vue({
    delimiters: ['[[', ']]'],
    el: '#app_attachments',
    data: function data() {
      return {
        attachments: [],
        nb: 0
      };
    },
    mounted: function mounted() {
      $.ajaxSetup({
        traditional: true
      });
    },
    methods: {
      getAttachments: function getAttachments() {
        this.attachments = [];
        var search = findGetParameter('attachments_search');
        var rubrics = findGetParameter('rubrics');
        var files = findGetParameter('files'); // authorsId = findGetParameter('authors');
        // cities = findGetParameter('regions');
        // event = findGetParameter('event');
        // if(search !== '' || category !== '' || date !== '' || authorsId !== '' || cities !== '' || event !== '') {
        // urlApi = '/api/v1/attachments?file_type=&file_type__in=&rubric=&rubric__in=&content_type='
        // }

        var urlApi = '/api/v1/attachments?search=' + search + '&file_type=&file_type__in' + files + '=&rubric=&rubric__in=' + rubrics + '&content_type=';
        console.log(urlApi);
        $.ajax({
          url: urlApi,
          method: 'GET',
          beforeSend: function beforeSend(request) {
            return request.setRequestHeader("Accept-Language", languageCode);
          },
          success: function success(response) {
            var results = response.results;
            vueAttachments.nb = response.count;
            vueAttachments.attachments = results;
            setTimeout(function () {
              asyncBg(function () {
                initAnimation();
              });
              $('.js-private-search-input').val(search);
              $('.js-open-modal').openModal();
              copyLink();
            }, 500);
          },
          error: function error(_error) {
            console.log(_error);
          }
        });
      }
    },
    filters: {
      date: function date(_date) {
        return moment(_date).format('DD.MM.YYYY');
      }
    }
  });
  vueAttachments.getAttachments();
}